import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, Input, Card, CardHeader, CardBody } from 'reactstrap'
import { addFileUploadReset, addFileUploadStart, getLeadsBulkUploads, revertBulkUpload } from 'store/actions';
import Loader from "common/Loader"
import { useSelector } from 'react-redux';
import bulkFileFormat from "./BulkUploadFormat/bulkLeads.xlsx"
import { toast } from 'react-toastify';
import TableContainer from 'components/Common/TableContainer';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

const LeadsBulkUpload = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [bulkModal, setBulkModal] = useState(false)
  const [revertModal, setRevertModal] = useState(false)
  const [selectedBulk, setSelectedBulk] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null)
  const { uploading, uploaded, bulkupload, bulkLeadsList, successMsg, error } = useSelector(state => state.fileUploadReducer)

  const toggleModal = () => {
    setBulkModal(!bulkModal)
    dispatch(addFileUploadReset())
  }

  const handleFileChange = e => {
    const file = e.target.files[0]
    if (file) {
      if (
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "text/csv"
      ) {
        setSelectedFile(file)
        //setError(null)
      } else {
        // setError("Invalid File format")
        toast.error("Please select a valid Excel or CSV file.")
      }
    }
  }

  const downloadCSV = () => {
    const a = document.createElement("a")
    a.href = bulkFileFormat
    a.download = `bulk_upload_format.xlsx`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }



  const handleFileUpload = e => {
    const formData = new FormData()
    formData.append("upload_name", "upload_name")
    formData.append("LeadsFile", selectedFile)

    dispatch(addFileUploadStart(formData))
    //setModalOpen(false)
  }

  const HandleRevertBulk = () => {
    dispatch(revertBulkUpload({ "bulkupload_id": selectedBulk.id, "upload_type": "leads" }))
    setRevertModal(false)
  }

  const columns = useMemo(
    () => [
      {
        Header: "Sr No",
        accessor: (row, i) => i + 1,
        filterable: true,
        Cell: ({ row }) => {
          return <>{row.index + 1}</>;
        },
      },
      {
        Header: "File Name",
        accessor: "filename",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              {cellProps.row.original.filename.substring(cellProps.row.original.filename.lastIndexOf('/') + 1)}
            </>
          );
        },
      },
      {
        Header: "Upload Name",
        accessor: "upload_name",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              {cellProps.row.original.upload_name}
            </>
          );
        },
      },
      {
        Header: "Total Records",
        accessor: "total_records",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              {cellProps.row.original ? cellProps.row.original.total_records : ""}
            </>
          );
        },
      },
      {
        Header: "Inserted Records",
        accessor: "inserted_records",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              {cellProps.row.original ? cellProps.row.original.inserted_records : ""}
            </>
          );
        },
      },
      {
        Header: "Updated Records",
        accessor: "updated_records",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              {cellProps.row.original ? cellProps.row.original.updated_records : ""}
            </>
          );
        },
      },
      {
        Header: "Failed Records",
        accessor: "failed_records",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              {cellProps.row.original ? cellProps.row.original.failed_records : ""}
            </>
          );
        },
      },
      {
        Header: "Duplicate Records",
        accessor: "duplicate_records",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              {cellProps.row.original ? cellProps.row.original.duplicate_records : ""}
            </>
          );
        },
      },
      {
        Header: "Status",
        accessor: "status",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              {cellProps.row.original ? cellProps.row.original.status : ""}
            </>
          );
        },
      },

      {
        Header: "Date",
        accessor: "date",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              {cellProps.row?.original?.date ? moment(cellProps.row.original.date).format("DD/MM/YYYY") : ""}
            </>
          );
        },
      },
      // {
      //   Header: "Uploaded By",
      //   accessor: "uploaded_by",
      //   filterable: true,
      //   Cell: cellProps => {
      //     return (
      //       <>
      //         {cellProps.row.original ? cellProps.row.original.uploaded_by : ""}
      //       </>
      //     );
      //   },
      // },
      {
        Header: "Action",
        accessor: "lead_status",
        filterable: true,
        Cell: cellProps => {
          return (
            <Button
              color={cellProps.row.original.status !== "Reverted" ? 'primary' : 'secondary'}
              style={{ minWidth: "130px", fontSize: "10px" }}
              disabled={cellProps.row.original.status == "Reverted"}
              onClick={() => {
                setSelectedBulk(cellProps.row.original)
                setRevertModal(true)
              }}
            >
              Revert
            </Button>
          );
        },
      },
    ],
    []
  );

  useEffect(() => {
    if (uploaded) {
      dispatch(getLeadsBulkUploads())
    }
  }, [uploaded])


  useEffect(() => {
    dispatch(getLeadsBulkUploads())
  }, [])

  useEffect(() => {
    if (successMsg && successMsg !== null) {
      toast.success(successMsg)
    }
  }, [successMsg])

  useEffect(() => {
    toast.error(error)
  }, [error])

  return (
    <div className='page-content'>
      <div className='d-flex justify-content-between align-items-center'>
        <h2>Leads Bulk Uploads</h2>
        <div>
          <Button color='primary' onClick={toggleModal}>New Bulk Upload</Button>
          <button
            onClick={() => navigate(-1)}
            className="btn btn-light ms-2"
          >
            Back 
          </button>
        </div>
      </div>


      <div>
        {/* Tables DIv */}
        <TableContainer

          columns={columns}
          Loading={uploading}
          data={bulkLeadsList}
          isGlobalFilter={false}
          isAddOptions={false}
          // handleJobClicks={handleJobClicks}
          isJobListGlobalFilter={false}
          isPagination={true}
          iscustomPageSizeOptions={true}
          isShowingPageLength={true}
          customPageSize={20}
          tableClass="table-bordered align-middle nowrap mt-2"
          paginationDiv="col-sm-12 col-md-7"
          pagination="pagination justify-content-end pagination-rounded"
        />
      </div>


      <div>
        {/* Bulk Upload Modal Div */}
        <Modal isOpen={bulkModal} toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>
            Upload File
          </ModalHeader>
          <ModalBody>
            <Input
              type="file"
              accept=".xlsx,.csv"
              onChange={handleFileChange}
            />
          </ModalBody>
          {uploading ? (
            <Loader />
          ) : (
            <>
              {bulkupload &&
                Object.keys(bulkupload).length > 0 && (
                  <>
                    <Card className="mx-1">
                      <CardHeader>
                        <b>Uploading Status:</b>
                      </CardHeader>
                      <CardBody
                        style={{ backgroundColor: "#ffeeba" }}
                      >
                        <div className="">
                          {bulkupload.message
                            ? bulkupload.message
                            : ""}
                        </div>
                      </CardBody>
                    </Card>

                    <Card className="mx-1">
                      <CardHeader>
                        <b>Duplicate Leads:</b>
                      </CardHeader>
                      <CardBody
                        style={{ backgroundColor: "#d4edda" }}
                      >
                        {bulkupload.duplicateLeadsMsg &&
                          bulkupload.duplicateLeadsMsg.length >
                          0 ? (
                          <ul>
                            {bulkupload.duplicateLeadsMsg.map(
                              (msg, index) => (
                                <div key={index}>
                                  <li className="mt-1">
                                    {" "}
                                    {msg
                                      .split("")
                                      .map(
                                        (letter, index) => (
                                          <span
                                            key={index}
                                            style={{
                                              color: "blue",
                                            }}
                                          >
                                            {letter}
                                          </span>
                                        )
                                      )}
                                  </li>
                                </div>
                              )
                            )}
                          </ul>
                        ) : (
                          <div>No duplicate Leads</div>
                        )}
                      </CardBody>
                    </Card>

                    <Card className="mx-1">
                      <CardHeader>
                        <b> Partial Duplicate Leads:</b>
                      </CardHeader>
                      <CardBody
                        style={{ backgroundColor: "#cfe2f3" }}
                      >
                        <ul>
                          {bulkupload.partiallyDublicateLeadsMsg &&
                            bulkupload
                              .partiallyDublicateLeadsMsg
                              .length > 0 ? (
                            bulkupload.partiallyDublicateLeadsMsg.map(
                              (msg, index) => (
                                <div key={index}>
                                  <li>
                                    {" "}
                                    {msg
                                      .split("")
                                      .map(
                                        (letter, index) => (
                                          <span
                                            key={index}
                                            style={{
                                              color: "black",
                                            }}
                                          >
                                            {letter}
                                          </span>
                                        )
                                      )}
                                  </li>
                                </div>
                              )
                            )
                          ) : (
                            <li>
                              No Partial duplicate Leads
                            </li>
                          )}
                        </ul>
                      </CardBody>
                    </Card>
                    <Card className="mx-1">
                      <CardHeader>
                        <b>Failed Leads:</b>
                      </CardHeader>
                      <CardBody
                        style={{ backgroundColor: "#f8d7da" }}
                      >
                        <ul>
                          {bulkupload.FailedLeadsMsg &&
                            bulkupload.FailedLeadsMsg.length >
                            0 ? (
                            bulkupload.FailedLeadsMsg.map(
                              (msg, index) => (
                                <div key={index}>
                                  <li>
                                    {" "}
                                    {msg
                                      .split("")
                                      .map(
                                        (letter, index) => (
                                          <span
                                            key={index}
                                            style={{
                                              color: "red",
                                            }}
                                          >
                                            {letter}
                                          </span>
                                        )
                                      )}
                                  </li>
                                </div>
                              )
                            )
                          ) : (
                            <li>No Failed leads</li>
                          )}
                        </ul>
                      </CardBody>
                    </Card>
                  </>
                )}
            </>
          )}

          <ModalFooter>
            <Button color="primary" onClick={downloadCSV}>
              Download Format
            </Button>
            <Button
              color="primary"
              onClick={handleFileUpload}
            >
              Upload
            </Button>
            <Button color="secondary" onClick={toggleModal}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>


      <div>
        <Modal isOpen={revertModal} toggle={() => setRevertModal(false)}>
          <ModalHeader tag={"h4"} toggle={() => setRevertModal(false)}>
            Do you wants to revert this bulk upload ?
          </ModalHeader>

          <ModalBody>
            <table className='w-100'>
              <tr>
                <td className='fw-bold'>File Name</td>
                <td>: {selectedBulk && selectedBulk.filename ? selectedBulk.filename : ""}</td>
              </tr>

              <tr>
                <td className='fw-bold'>Upload Name</td>
                <td>: {selectedBulk && selectedBulk.upload_name ? selectedBulk.upload_name : ""}</td>
              </tr>
            </table>
          </ModalBody>

          <ModalFooter>
            <div className='d-flex justify-content-between align-items-center w-100'>
              <Button color='danger' onClick={HandleRevertBulk}>Revert Now</Button>
              <Button color='primary' onClick={() => setRevertModal(false)}>Cancel</Button>
            </div>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  )
}

export default LeadsBulkUpload